import { render } from "./DeleteUserConfirmationModal.vue?vue&type=template&id=f7b4a482&ts=true"
import script from "./DeleteUserConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteUserConfirmationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__